__turbopack_context__.v({
  "actions": "zpGwIW_actions",
  "container": "zpGwIW_container",
  "content": "zpGwIW_content",
  "group": "zpGwIW_group",
  "groupCards": "zpGwIW_groupCards",
  "list": "zpGwIW_list",
});
